<template>
  <v-col 
    :cols="cols"
    :xs="xs"
    :sm="sm"
    :md="md"
    :lg="lg"
    :xl="xl"
    :order="order" 
    class="ma-0 pa-0"
  >
    <slot />
  </v-col>
</template>

<script>
export default {
  name: 'AppModalCol',

  props: {
    cols: {
      type: [Boolean, String, Number],
      required: false,
    },
    xs: {
      type: [Boolean, String, Number],
      required: false,
    },
    sm: {
      type: [Boolean, String, Number],
      required: false,
    },
    md: {
      type: [Boolean, String, Number],
      required: false,
    },
    lg: {
      type: [Boolean, String, Number],
      required: false,
    },
    xl: {
      type: [Boolean, String, Number],
      required: false,
    },
    order: {
      type: [String, Number],
      required: false,
    }
  }
}
</script>

<style>

</style>